import classNames from 'classnames';
import React, { memo, ReactNode } from 'react';
import { PhiloLogo } from '../../icons/icon/philo-logo';
import { LoadingAnimation } from './loading-animation';
import styles from './loading-overlay.module.sass';

export const LoadingOverlay = memo(
  ({
    className,
    logo = <PhiloLogo />,
    children,
  }: {
    className?: string;
    children?: ReactNode;
    logo?: ReactNode;
  }) => (
    <div className={classNames(className, styles.loadingOverlay)}>
      <div className={styles.loadingOverlayLogo}>
        {logo}
        <LoadingAnimation className={styles.loadingOverlayAnimation} />
      </div>
      {children && <div className={styles.loadingOverlayContent}>{children}</div>}
    </div>
  ),
);
